<template>
  <div class="content-page">
    <div class="tab-content">
      <el-form
        :model="shopForm"
        :rules="shopFormRules"
        ref="shopForm"
        label-width="124px"
        class="shopsetting-form"
        width="328px"
        :hide-required-asterisk="true"
      >
        <el-form-item label="视频号">
          <el-switch v-model="videoSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="视频号主页ID" v-show="videoSwitch">
          <el-input
            v-model="shopForm.videoHomeId"
            placeholder="请输入视频号主页ID"
            type="text"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <el-switch v-model="couponSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="店主微信">
          <el-switch v-model="shoperWXSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="店主微信二维码" v-show="shoperWXSwitch">
          <el-upload
            :disabled="uploadDisabled"
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="
              (e) => {
                handleRemove(e, 'shopkeeperWechat');
              }
            "
            :http-request="
              (e) => {
                handleSuccess(e, 'shopkeeperWechat');
              }
            "
            :before-upload="beforeImgUpload"
            :file-list="shopkeeperWechat"
            :before-remove="beforeRemove"
          >
            <div
              style="width: 148px; height: 148px; position: absolute"
              @click="show_uploadDialog(1, 'shopkeeperWechat')"
            ></div>
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="滴滴打车券">
          <el-switch v-model="ddCouponWXSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="抽奖活动">
          <el-switch v-model="lotterySwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="抽奖活动" v-show="lotterySwitch">
          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/luckyLottery',
              })
            "
            >去配置</el-button
          >
        </el-form-item>
        <el-form-item label="推荐视频">
          <el-switch v-model="recommendVideoSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="视频号视频ID" v-show="recommendVideoSwitch">
          <el-tag
            :key="tagindex"
            v-for="(tag, tagindex) in shopForm.videoHomeVideoIds"
            closable
            :disable-transitions="false"
            @close="handleClose(tagindex)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="attrValueInputVisible"
            v-model="attrValueInputValue"
            :ref="`saveTagInput`"
            size="small"
            @keyup.enter.native="handleAttrValueInputConfirm()"
            @blur="handleAttrValueInputConfirm()"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showAttrValueInput()"
            >+ 添加</el-button
          >
        </el-form-item>
        <el-form-item label="主页关注领券(视频号活动)">
          <el-switch v-model="homePageSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="主页关注领券(视频号活动)" v-show="homePageSwitch">
          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/videoAccountActivities',
              })
            "
            >去配置</el-button
          >
        </el-form-item>
        <el-form-item label="视频点赞领券(视频号活动)">
          <el-switch v-model="videoLikesSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="视频点赞领券(视频号活动)" v-show="videoLikesSwitch">
          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/videoAccountActivities',
              })
            "
            >去配置</el-button
          >
        </el-form-item>
        <el-form-item label="转发朋友圈领券 (视频号活动)">
          <el-switch v-model="shareToMomentsSwitch" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="转发朋友圈领券 (视频号活动)" v-show="shareToMomentsSwitch">
          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/videoAccountActivities',
              })
            "
            >去配置</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('shopForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
      <uploadImgComponent
        :isshow_uploadDialog="isshow_uploadDialog"
        @onClose="close_uploadDialog"
        @getChoose_ImgUrl="getChoose_ImgUrl"
        ref="childRef"
        :ImgLimits="ImgLimits"
        :uploadName="uploadName"
      ></uploadImgComponent>
    </div>
  </div>
</template>

<script>
import {
  uploadVideo,
  uploadImg,
  modifyShopInfo,
  uploadFile,
  getShopInfo,
} from "@/api/index.js";
import { mapState, mapActions } from "vuex";
import uploadImgComponent from "@/components/uploadImg";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      introduceVideoUrl: [],
      shopForm: {
        adCommand: "",
        introduceVideoUrl: "",
        introduceImages: "",
        introduceContent: "",
        videoHomeImage: "",
        videoHomeId: "",
        shopkeeperWechat: "",
        videoHomeVideoIds: [],
        entrysAfterPay: [],
      },
      shopFormRules: {},
      videoHomeImage: [],
      isshow_uploadDialog: false,
      uploadDisabled: false,
      shopImages: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ size: ["small", false, "large", "huge"] }],
            [{ font: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ header: 1 }, { header: 2 }],
            ["image"],
            [{ direction: "rtl" }], //文字编辑方向，从左到右还是从右到左
            [{ color: [] }, { background: [] }],
          ],
        },
        placeholder: "请输入内容...",
      },
      ImgLimits: 0,
      uploadName: "",
      shopkeeperWechat: [],
      attrValueInputVisible: false,
      attrValueInputValue: "",
      switchMap: {
        1: "videoSwitch",
        2: "couponSwitch",
        3: "shoperWXSwitch",
        4: "ddCouponWXSwitch",
        5: "lotterySwitch",
        6: "recommendVideoSwitch",
        7: "homePageSwitch",
        8: "videoLikesSwitch",
        9: "shareToMomentsSwitch",
      },
      videoSwitch: false,
      couponSwitch: false,
      shoperWXSwitch: false,
      ddCouponWXSwitch: false,
      lotterySwitch: false,
      homePageSwitch: false,
      videoLikesSwitch: false,
      shareToMomentsSwitch: false,
      recommendVideoSwitch: false,
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  components: {
    uploadImgComponent,
    quillEditor,
  },
  mounted() {
    let url = window.location.href;
    if (this.$refs.myQuillEditor) {
      this.$refs.myQuillEditor.quill
        .getModule("toolbar")
        .addHandler("image", this.imgHandler);
    }
    getShopInfo().then((shopInfo) => {
      console.log(shopInfo);
      if (shopInfo.data.introduceImages) {
        let introduceImages = shopInfo.data.introduceImages.split(",");
        // console.log(introduceImages, "introduceImages")
        introduceImages.forEach((ele) => {
          this.shopImages.push({ url: ele });
        });
      }

      if (shopInfo.data.introduceVideoUrl) {
        let introduceVideoUrl = shopInfo.data.introduceVideoUrl.split(",");
        introduceVideoUrl.forEach((ele) => {
          this.introduceVideoUrl.push({ url: ele });
        });
        console.log(this.introduceVideoUrl, "introduceVideoUrl");
      }
      if (shopInfo.data.videoHomeImage) {
        let videoHomeImage = shopInfo.data.videoHomeImage.split(",");
        // console.log(introduceImages, "introduceImages")
        videoHomeImage.forEach((ele) => {
          this.videoHomeImage.push({ url: ele });
        });
      }
      if (shopInfo.data.shopkeeperWechat) {
        let shopkeeperWechat = shopInfo.data.shopkeeperWechat.split(",");
        shopkeeperWechat.forEach((ele) => {
          this.shopkeeperWechat.push({ url: ele });
        });
      }
      shopInfo.data.entrysAfterPay = shopInfo.data.entrysAfterPay
        ? shopInfo.data.entrysAfterPay.split(",")
        : [];
      shopInfo.data.entrysAfterPay.forEach((val) => {
        this[this.switchMap[val]] = true;
      });
      shopInfo.data.videoHomeVideoIds = shopInfo.data.videoHomeVideoIds
        ? shopInfo.data.videoHomeVideoIds.split(",")
        : [];
      Object.assign(this.shopForm, shopInfo.data);
    });
  },
  methods: {
    handleClose(index) {
      this.shopForm.videoHomeVideoIds.splice(index, 1);
    },
    handleAttrValueInputConfirm() {
      let attrValueInputValue = this.attrValueInputValue;
      if (attrValueInputValue) {
        this.shopForm.videoHomeVideoIds.push(attrValueInputValue);
      }
      this.attrValueInputVisible = false;
      this.attrValueInputValue = "";
    },

    showAttrValueInput() {
      this.attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput`].focus();
      });
    },
    handleRemoveVideo() {
      this.shopForm.introduceVideoUrl = "";
    },
    handleSuccessVideo(res) {
      let videoUploadForm = new FormData();
      videoUploadForm.append("file", res.file);
      videoUploadForm.append("fileContentType", res.file.type);
      videoUploadForm.append("fileFileName", res.file.name);
      videoUploadForm.append("isCompre", 1);
      videoUploadForm.append("isCutImage", 1);
      uploadVideo(videoUploadForm).then((res) => {
        if (res.code == 1) {
          this.shopForm.introduceVideoUrl = res.data.url;
        }
      });
    },
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      // return
      if (val.length > 0) {
        if (this[name].length >= this.ImgLimits) {
          return this.$notify.warning("所选图片已达限制");
        }
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            this.shopForm.introduceImages += `,${item.image}`;
            if (this.shopForm.introduceImages.substr(0, 1) == ",")
              this.shopForm.introduceImages = this.shopForm.introduceImages.substr(1);
            this.shopImages.push({ name: "", url: item.image });
          } else if (name == "videoHomeImage") {
            this.shopForm.videoHomeImage = `${item.image}`;
            this.videoHomeImage.push({ name: "", url: item.image });
          } else if (name == "shopkeeperWechat") {
            this.shopForm.shopkeeperWechat = `${item.image}`;
            this.shopkeeperWechat.push({ name: "", url: item.image });
          }
        });
      }
      // this.$refs["shopForm"].validate();
    },
    ...mapActions(["updateShopInfo"]),
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "shopImages") {
        let shopImages1 = this.shopForm.introduceImages.split(",");
        let shopImages2 = this.shopForm.introduceImages.split(",");
        shopImages1.splice(shopImages1.indexOf(file.url), 1);
        this.shopForm.introduceImages = shopImages1.join(",");
        this.shopImages.splice(shopImages2.indexOf(file.url), 1);
      } else {
        this.shopForm[name] = "";
        this[name] = [];
      }
    },
    beforeRemove(file, fileList) {},
    beforeImgUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(item, name) {
      console.log(item, "上传成功");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          console.log(res, "上传成功");
          // this.shopForm.introduceImages += `,${item.image}`
          // if (this.shopForm.introduceImages.substr(0,1) == ',')  this.shopForm.introduceImages=this.shopForm.introduceImages.substr(1);
          //   if (name == "shopImages") {
          //     if (this.shopForm[name].length) {
          //       this.shopForm[name] += `,${res.data.url}`;
          //     } else {
          //       this.shopForm[name] = res.data.url;
          //     }
          //     return;
          //   }
          //   this.shopForm[name] = res.data.url;
        }
      });
    },
    imgHandler(state) {
      if (state) {
        this.$refs.fileBtn.click();
      }
    },
    handleUpload(e) {
      console.log(e, 123);
      const files = Array.prototype.slice.call(e.target.files);
      // console.log(files, "files")
      if (!files) {
        return;
      }
      let formdata = new FormData();
      formdata.append("file", files[0]);
      uploadFile(formdata).then((res) => {
        console.log(res, 789);
        if (res.data.url) {
          let selection = this.$refs.myQuillEditor.quill.getSelection();
          //这里就是返回的图片地址，如果接口返回的不是可以访问的地址，要自己拼接
          let imgUrl = res.data.url;
          //获取quill的光标，插入图片
          this.$refs.myQuillEditor.quill.insertEmbed(
            selection != null ? selection.index : 0,
            "image",
            imgUrl
          );
          //插入完成后，光标往后移动一位
          this.$refs.myQuillEditor.quill.setSelection(selection.index + 1);
        }
      });
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.shopForm.entrysAfterPay = [];
          Object.entries(this.switchMap).forEach((val) => {
            if (this[val[1]]) {
              this.shopForm.entrysAfterPay.push(val[0]);
            }
          });
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));

          shopForm.entrysAfterPay = shopForm.entrysAfterPay.join(",");
          shopForm.videoHomeVideoIds = shopForm.videoHomeVideoIds.join(",");
          modifyShopInfo(shopForm).then((res) => {
            console.log(123);
            if (res.code == 1) {
              getShopInfo().then((shopInfo) => {
                this.updateShopInfo(shopInfo.data);
                if (cb) {
                  cb(shopInfo.data);
                  return;
                }
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .avatar {
  width: 300px;
  height: 300px;
}
/deep/ .ql-editor {
  width: 50%;
  min-height: 300px;
}
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .shopsetting-form {
    width: 100%;
    .el-tag {
      margin-right: 10px;
    }
    .qrcode-img {
      display: inline-block;
      position: relative;
      left: 0px;
      bottom: 0px;
      width: 300px;
      height: 450px;
      margin-right: 10px;
      .bg {
        width: 100%;
        height: 100%;
      }
      .logo {
        position: absolute;
        width: 30px;
        height: 30px;
        right: 136px;
        left: 140.5px;
        top: 243px;
        border-radius: 4px;
      }
      .name {
        position: absolute;
        display: block;
        width: 172px;
        color: #d07910;
        font-size: 10.8px;
        bottom: 64px;
        left: 72px;
        text-align: center;
      }
      .phone {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 35px;
        left: 0;
        text-align: center;
        font-weight: bold;
      }
      .addresss {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 17px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
        white-space: nowrap;
        overflow: hidden;
      }
      .info {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: -1px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
      }
      .scan-code-img {
        position: absolute;
        display: block;
        bottom: 147px;
        left: 111px;
      }
    }
    .el-form-item__content {
      .el-input,
      .el-textarea,
      .el-cascader {
        width: 380px;
      }
      .taxnum-input {
        width: 200px;
        margin-right: 10px;
      }
      .el-date-editor {
        width: 182px;
        margin-right: 14px;
      }
      .func-container {
        width: 144px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-right: 20px;
      }
      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #f56c6c;
        margin-left: 10px;
        & > i {
          margin-right: 6px;
        }
        .el-link {
          font-size: 14px;
          vertical-align: baseline;
          margin-left: 10px;
        }
      }
      .verified-status {
        margin-right: 18px;
      }
    }
    .submit-btn-container {
      margin: 40px 0 200px 0;
    }
    .inline-title {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      padding-left: 20px;
      background: #f8f8f8;
      margin: 45px 0 24px 0;
    }
    .el-radio {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
